import { HelmetDexteel } from "@dexteel/mesf-core";
import { PassTypesManager } from "./components/PassTypesManager";

export const PassTypesPage = () => {
	return (
		<>
			<HelmetDexteel title="Pass Types" />
			<PassTypesManager />
		</>
	);
};
